var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("Авторизация")]),(_vm.error)?_c('div',[_c('p',[_vm._v("Не удалось авторизоваться. Возникла ошибка: "+_vm._s(_vm.error))]),_c('p',[_c('router-link',{attrs:{"to":{ name: 'login' }}},[_vm._v("Перейти ко входу")])],1)]):_c('p',[_vm._v("Подождите немного...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }